<template>
  <b-card>
    <title-name />
  </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import TitleName from '@/views/Admin/Defines/TeamTypes/elements/Title.vue'

export default {
  name: 'TeamTypesForm',
  components: {
    BCard,
    TitleName,
  },
}
</script>
